import { ReactElement } from 'react';
import {
    CircleAlertIcon,
    CircleMinusIcon,
    CircleXIcon,
    InfoIcon,
} from 'lucide-react';

export type AlertBadgeType = 'info' | 'warning' | 'error' | 'denied';

type Schema = {
    icon: ReactElement;
    bgColor: string;
    primaryColor: string;
    borerColor: string;
};

export const mapper: Record<AlertBadgeType, Schema> = {
    info: {
        icon: <InfoIcon size={14} color="#6a41c6" />,
        bgColor: '#faf5ff',
        primaryColor: '#6a41c6',
        borerColor: '#e9d7fe',
    },
    warning: {
        icon: <CircleAlertIcon size={14} color="#f79007" />,
        bgColor: '#fffaeb',
        primaryColor: '#f79007',
        borerColor: '#fedf89',
    },
    denied: {
        icon: <CircleMinusIcon size={14} color="#d41111" />,
        bgColor: '#fff4f6',
        primaryColor: '#d41111',
        borerColor: '#fbd3dc',
    },
    error: {
        icon: <CircleXIcon size={14} color="#d41111" />,
        bgColor: '#fff4f6',
        primaryColor: '#d41111',
        borerColor: '#fbd3dc',
    },
};
